module.exports = __webpack_public_path__ + "static/megamenu-banners-2a7bf75d848f6a3007836b52e368d266.png";